export default {
    zh: {
        // 页面标题和描述
        pageTitle: 'Werydance 2.0 AI视频生成器 - 导演级精准控制视频创作工具',
        pageDescription:
            '体验WeryAI Werydance 2.0 AI视频生成器，支持多模态参考输入、导演级指令遵循、长镜头叙事一致性和物理规律模拟。在WeryAI平台免费试用，创造专业级AI视频内容。',
        pageKeywords:
            'Werydance 2.0, WeryAI, 即梦AI, AI视频生成器, 导演级控制, 多模态视频, 物理模拟, 口型同步, 文生视频, 图生视频, 免费AI视频, WeryAI',

        // 生成器部分
        generatorTitle: 'Werydance 2.0 视频生成器',
        generatorDescription:
            'WeryAI 推出了 <span class="text-text-active">Werydance 2.0</span>，这是一款旗舰级AI视频生成模型，彻底改变了传统AI视频"抽卡"式的不确定性，通过强大的语义理解和物理规律模拟，实现了"指令即所得"的导演级精准控制。现已在 <span class="text-text-active">WeryAI 视频生成器上可用，点击此处免费试用</span>！',

        // 标签页
        tabImageToVideo: '图生视频',
        tabTextToVideo: '文生视频',

        // 核心功能部分
        coreFeaturesTitle: 'Werydance 2.0 的核心功能',

        // 全能多模态参考
        multiModalReferenceTitle: '全能多模态参考',
        multiModalReferenceDescription:
            '打破了单一输入的限制，支持图像（定风格/角色）、视频（定动作/运镜）、音频（定节奏/口型）的混合输入。模型能精准提取各参考源的特征并完美融合，例如根据一张照片和一段音频，生成角色精准对口型的演唱MV。',

        // 导演级指令遵循
        directorLevelControlTitle: '导演级指令遵循',
        directorLevelControlDescription:
            '解决了AI视频"听不懂人话"的痛点。Werydance 2.0 能一次性理解并执行复杂的复合指令，无需反复生成筛选。无论是复杂的交互动作还是特定的各种运镜要求，都能精准呈现，大幅降低废片率。',

        // 长镜头与叙事一致性
        narrativeConsistencyTitle: '长镜头与叙事一致性',
        narrativeConsistencyDescription:
            '在生成多镜头或续集视频时，模型能保持极高的人物和场景一致性。配合分镜工作流，用户可以制作包含对话、剧情推进的连续短剧，而不用担心角色"换脸"或场景突变。',

        // 物理规律与特效模拟
        physicsVFXTitle: '物理规律与特效模拟',
        physicsVFXDescription:
            '攻克了AI视频常见的"物理幻觉"问题。在处理大规模战斗、物体碰撞、流体运动等复杂场景时，Werydance 2.0 表现出对真实物理世界的深刻理解，动作流畅自然，不再有违和的穿模或扭曲。',

        // 如何使用部分
        howToUseTitle: '如何使用',
        howToUseSubtitle: '简单三步，开始创作',
        step1Title: '选择 Werydance 2.0 模型',
        step1Description:
            '前往<span class="highlight-text">"图像转视频AI"</span>页面，然后在模型下拉菜单中点击"Werydance 2.0"。',
        step2Title: '输入提示词，调整参数',
        step2Description: '描述您想要的画面或上传图片，设置视频时长（最高15秒）、比例，并选择是否开启"音画同步"功能。',
        step3Title: '生成与下载',
        step3Description: '点击"生成"，等待导演级大片渲染完成，即可随意下载或分享。',

        // YouTube 视频部分
        youtubeTitle: '关于 Werydance 2.0 视频模型的 YouTube 视频',

        // X Posts 部分
        xPostsTitle: '关于 Werydance 2.0 视频模型的 X 帖子',

        // 探索其他模型部分
        exploreModelsTitle: '探索其他模型',
        veo31Title: 'Google Veo 3.1 AI 视频生成器',
        klingTitle: 'Kling AI 视频生成器',
        weryaiVideoTitle: 'WeryAI Video 1.0 视频生成器',

        // FAQ 部分
        faqTitle: '常见问题解答',

        // CTA 部分
        ctaTitle: '准备开始创作了吗？',
        ctaDescription: '立即体验 Werydance 2.0，将您的创意转化为导演级大片',
        ctaButton: '在WeryAI上试用Werydance 2.0',
        ctaDisclaimer: '无需信用卡',
        pageDisclaimer:
            '免责声明：WeryAI 是一款独立运营的产品/平台，与字节跳动（ByteDance）及 Seedance 没有任何关联，也未获得其认可、授权或赞助。我们仅通过定制界面及 API 技术，为用户提供访问及使用 Seedance 2.0 模型的便捷途径。',
    },
    en: {
        // Page title and description
        pageTitle: 'Werydance 2.0 AI Video Generator - Director-Level Control Video Creation Tool',
        pageDescription:
            'Experience WeryAI Werydance 2.0 AI video generator with multi-modal reference inputs, director-level instruction following, long-shot narrative consistency, and physics simulation. Try it free on WeryAI platform.',
        pageKeywords:
            'Werydance 2.0, Seedance AI, WeryAI, Jimeng AI, AI video generator, director-level video, multi-modal video, physics simulation, lip-sync, text to video, image to video, free AI video, WeryAI',

        // Generator section
        generatorTitle: 'Werydance 2.0 Video Generator',
        generatorDescription:
            'WeryAI released <span class="text-text-active">Werydance 2.0</span>, a flagship AI video generation model that eliminates the randomness of traditional AI video creation. Through powerful semantic understanding and physics simulation, it achieves director-level precise control. It\'s now available on <span class="text-text-active">WeryAI video generator, click here to try for free</span>!',

        // Tabs
        tabImageToVideo: 'Image to Video',
        tabTextToVideo: 'Text to Video',

        // Core features section
        coreFeaturesTitle: 'Werydance 2.0 Core Features',

        // Multi-modal Reference
        multiModalReferenceTitle: 'Multi-modal Reference',
        multiModalReferenceDescription:
            'Breaks the limitation of single input, supporting mixed inputs of images (for style/character), videos (for motion/camera), and audio (for rhythm/lip-sync). The model precisely extracts features from each reference source and blends them perfectly, such as generating a singing MV with precise lip-sync from a photo and an audio clip.',

        // Director-Level Control
        directorLevelControlTitle: 'Director-Level Control',
        directorLevelControlDescription:
            'Solves the pain point of AI videos not understanding complex instructions. Werydance 2.0 can understand and execute complex compound instructions in one go, without repeated generation and filtering. Whether it\'s complex interactive actions or specific camera movement requirements, it delivers precise results, dramatically reducing wasted outputs.',

        // Narrative Consistency
        narrativeConsistencyTitle: 'Long-shot & Narrative Consistency',
        narrativeConsistencyDescription:
            'When generating multi-shot or sequel videos, the model maintains extremely high character and scene consistency. Combined with storyboard workflows, users can create continuous short dramas with dialogue and plot progression without worrying about character face-swapping or sudden scene changes.',

        // Physics & VFX
        physicsVFXTitle: 'Physics & VFX Simulation',
        physicsVFXDescription:
            'Overcomes the common "physics hallucination" problem in AI videos. When handling complex scenes like large-scale battles, object collisions, and fluid motion, Werydance 2.0 demonstrates deep understanding of the real physical world with smooth, natural actions and no jarring clipping or distortion.',

        // How to use section
        howToUseTitle: 'How to Use',
        howToUseSubtitle: 'Three simple steps to get started',
        step1Title: 'Select Werydance 2.0 Model',
        step1Description:
            'Go to the <span class="highlight-text">"Image to Video AI"</span> page, then click "Werydance 2.0" in the model dropdown menu.',
        step2Title: 'Enter Prompt & Adjust Settings',
        step2Description: 'Describe the scene you want or upload an image, set video duration (up to 15s), aspect ratio, and choose whether to enable "audio-visual sync".',
        step3Title: 'Generate & Download',
        step3Description:
            'Click "Create" and wait for your director-level video to render. Download or share freely.',

        // YouTube videos section
        youtubeTitle: 'YouTube Videos About Werydance 2.0 Video Model',

        // X Posts section
        xPostsTitle: 'X Posts About Werydance 2.0 Video Model',

        // Explore other models section
        exploreModelsTitle: 'Explore Other Models',
        veo31Title: 'Google Veo 3.1 AI Video Generator',
        klingTitle: 'Kling AI Video Generator',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generator',

        // FAQ section
        faqTitle: 'Frequently Asked Questions',

        // CTA section
        ctaTitle: 'Ready to Start Creating?',
        ctaDescription: 'Try Werydance 2.0 now and turn your ideas into director-level videos',
        ctaButton: 'Try Werydance 2.0 on WeryAI',
        ctaDisclaimer: 'No credit card required',
        pageDisclaimer:
            'Disclaimer: WeryAI is an independently operated product/platform and has no affiliation with ByteDance or Seedance, nor has it received any endorsement, authorization, or sponsorship from them. We simply provide users with a convenient way to access and use the Seedance 2.0 model through a customized interface and API technology.',
    },
    ja: {
        pageTitle: 'Werydance 2.0 AI動画生成ツール - ディレクターレベルの精密制御',
        pageDescription:
            'WeryAI Werydance 2.0 AI動画ジェネレーターを体験。マルチモーダル参照入力、ディレクターレベルの指示追従、長回し物語の一貫性、物理法則シミュレーションに対応。WeryAIで無料体験。',
        pageKeywords:
            'Werydance 2.0, Seedance AI, WeryAI, 即夢AI, AI動画生成, 監督級制御, マルチモーダル動画, 物理シミュレーション, リップシンク, テキストから動画, 無料AI動画, WeryAI',

        generatorTitle: 'Werydance 2.0 動画ジェネレーター',
        generatorDescription:
            'WeryAIが<span class="text-text-active">Werydance 2.0</span>をリリースしました。従来のAI動画の不確実性を解消し、強力な意味理解と物理法則シミュレーションにより、ディレクターレベルの精密な制御を実現するフラッグシップAI動画生成モデルです。<span class="text-text-active">WeryAI動画ジェネレーターで無料体験可能です</span>！',

        tabImageToVideo: '画像から動画',
        tabTextToVideo: 'テキストから動画',

        coreFeaturesTitle: 'Werydance 2.0 のコア機能',

        multiModalReferenceTitle: 'マルチモーダル参照',
        multiModalReferenceDescription:
            '単一入力の制限を突破し、画像（スタイル/キャラクター指定）、動画（動き/カメラ指定）、音声（リズム/口パク指定）の混合入力に対応。各参照源から特徴を正確に抽出し完璧に融合します。',

        directorLevelControlTitle: 'ディレクターレベルの指示追従',
        directorLevelControlDescription:
            'AI動画が「複雑な指示を理解できない」という課題を解決。Werydance 2.0は複雑な複合指示を一度で理解し実行でき、繰り返しの生成やフィルタリングが不要です。',

        narrativeConsistencyTitle: '長回しと物語の一貫性',
        narrativeConsistencyDescription:
            'マルチショットや続編動画を生成する際、キャラクターとシーンの一貫性を極めて高く維持します。ストーリーボードワークフローと組み合わせて、対話や展開のある連続ドラマを制作できます。',

        physicsVFXTitle: '物理法則とVFXシミュレーション',
        physicsVFXDescription:
            'AI動画に共通する「物理的幻覚」問題を克服。大規模バトル、物体の衝突、流体の動きなどの複雑なシーンで、スムーズで自然な動きを実現します。',

        howToUseTitle: '使い方',
        howToUseSubtitle: '3つの簡単なステップ',
        step1Title: 'Werydance 2.0モデルを選択',
        step1Description:
            '<span class="highlight-text">「画像から動画AI」</span>ページに移動し、モデルドロップダウンメニューから「Werydance 2.0」をクリックします。',
        step2Title: 'プロンプト入力とパラメータ調整',
        step2Description: '作りたいシーンを説明するか画像をアップロードし、動画の長さ（最大15秒）、比率を設定し、「音声同期」機能の有効化を選択します。',
        step3Title: '生成とダウンロード',
        step3Description: '「作成」をクリックし、ディレクターレベルの動画が完成するのを待ちます。自由にダウンロードまたは共有できます。',

        youtubeTitle: 'Werydance 2.0 動画モデルに関するYouTube動画',
        xPostsTitle: 'Werydance 2.0 動画モデルに関するX投稿',

        exploreModelsTitle: '他のモデルを探索',
        veo31Title: 'Google Veo 3.1 AI動画ジェネレーター',
        klingTitle: 'Kling AI動画ジェネレーター',
        weryaiVideoTitle: 'WeryAI Video 1.0 ジェネレーター',

        faqTitle: 'よくある質問',

        ctaTitle: '創作を始める準備はできましたか？',
        ctaDescription: '今すぐWerydance 2.0を体験し、あなたのアイデアをディレクターレベルの動画に変えましょう',
        ctaButton: 'WeryAIでWerydance 2.0を試す',
        ctaDisclaimer: 'クレジットカード不要',
        pageDisclaimer:
            '免責事項：WeryAI は独立して運営される製品/プラットフォームであり、ByteDance および Seedance とは一切関係がなく、それらから承認、認可、またはスポンサー提供を受けていません。私たちは、カスタマイズされたインターフェースと API 技術を通じて、ユーザーが Seedance 2.0 モデルに便利にアクセスし利用できる手段を提供しているだけです。',
    },
    ko: {
        pageTitle: 'Werydance 2.0 AI 비디오 생성기 - 감독급 정밀 제어 비디오 제작 도구',
        pageDescription:
            'WeryAI Werydance 2.0 AI 비디오 생성기를 경험하세요. 멀티모달 참조 입력, 감독급 지시 따르기, 롱테이크 내러티브 일관성, 물리 법칙 시뮬레이션을 지원합니다. WeryAI에서 무료 체험하세요.',
        pageKeywords:
            'Werydance 2.0, Seedance AI, WeryAI, AI 비디오 생성기, 감독급 제어, 멀티모달 비디오, 물리 시뮬레이션, 립싱크, 텍스트 투 비디오, 무료 AI 비디오, WeryAI',

        generatorTitle: 'Werydance 2.0 비디오 생성기',
        generatorDescription:
            'WeryAI가 <span class="text-text-active">Werydance 2.0</span>을 출시했습니다. 기존 AI 비디오의 불확실성을 해소하고 강력한 의미 이해와 물리 법칙 시뮬레이션을 통해 감독급 정밀 제어를 실현하는 플래그십 AI 비디오 생성 모델입니다. <span class="text-text-active">WeryAI 비디오 생성기에서 무료로 체험하세요</span>!',

        tabImageToVideo: '이미지를 비디오로',
        tabTextToVideo: '텍스트를 비디오로',
        coreFeaturesTitle: 'Werydance 2.0 핵심 기능',
        multiModalReferenceTitle: '멀티모달 참조',
        multiModalReferenceDescription:
            '단일 입력의 한계를 돌파하여 이미지(스타일/캐릭터), 비디오(동작/카메라), 오디오(리듬/립싱크)의 혼합 입력을 지원합니다. 각 참조 소스에서 특징을 정확하게 추출하여 완벽하게 융합합니다.',
        directorLevelControlTitle: '감독급 지시 따르기',
        directorLevelControlDescription:
            'AI 비디오가 복잡한 지시를 이해하지 못하는 문제를 해결합니다. Werydance 2.0은 복합 지시를 한 번에 이해하고 실행하여 반복적인 생성과 필터링이 필요 없습니다.',
        narrativeConsistencyTitle: '롱테이크 및 내러티브 일관성',
        narrativeConsistencyDescription:
            '멀티샷 또는 후속 비디오를 생성할 때 캐릭터와 장면의 일관성을 극도로 높게 유지합니다. 스토리보드 워크플로우와 결합하여 대화와 스토리 전개가 있는 연속 단편극을 제작할 수 있습니다.',
        physicsVFXTitle: '물리 법칙 및 VFX 시뮬레이션',
        physicsVFXDescription:
            'AI 비디오의 일반적인 "물리적 환각" 문제를 극복합니다. 대규모 전투, 물체 충돌, 유체 운동 등 복잡한 장면에서 부드럽고 자연스러운 동작을 구현합니다.',
        howToUseTitle: '사용 방법',
        howToUseSubtitle: '간단한 3단계',
        step1Title: 'Werydance 2.0 모델 선택',
        step1Description:
            '<span class="highlight-text">"이미지를 비디오 AI"</span> 페이지로 이동하여 모델 드롭다운 메뉴에서 "Werydance 2.0"을 클릭합니다.',
        step2Title: '프롬프트 입력 및 설정 조정',
        step2Description: '원하는 장면을 설명하거나 이미지를 업로드하고, 비디오 길이(최대 15초), 비율을 설정하고 "오디오-비주얼 동기화" 기능 활성화 여부를 선택합니다.',
        step3Title: '생성 및 다운로드',
        step3Description: '"생성"을 클릭하고 감독급 비디오가 완성되기를 기다립니다. 자유롭게 다운로드하거나 공유하세요.',
        youtubeTitle: 'Werydance 2.0 비디오 모델에 관한 YouTube 동영상',
        xPostsTitle: 'Werydance 2.0 비디오 모델에 관한 X 게시물',
        exploreModelsTitle: '다른 모델 탐색',
        veo31Title: 'Google Veo 3.1 AI 비디오 생성기',
        klingTitle: 'Kling AI 비디오 생성기',
        weryaiVideoTitle: 'WeryAI Video 1.0 생성기',
        faqTitle: '자주 묻는 질문',
        ctaTitle: '창작을 시작할 준비가 되셨나요?',
        ctaDescription: '지금 Werydance 2.0을 체험하고 아이디어를 감독급 비디오로 만들어보세요',
        ctaButton: 'WeryAI에서 Werydance 2.0 체험하기',
        ctaDisclaimer: '신용카드 불필요',
        pageDisclaimer:
            '면책 조항: WeryAI는 독립적으로 운영되는 제품/플랫폼이며 ByteDance 및 Seedance와 어떠한 관련도 없고, 그들로부터 승인, 허가 또는 후원을 받은 바도 없습니다. 당사는 맞춤형 인터페이스와 API 기술을 통해 사용자가 Seedance 2.0 모델에 편리하게 접근하고 사용할 수 있는 방법만 제공합니다.',
    },
    tw: {
        pageTitle: 'Werydance 2.0 AI影片生成器 - 導演級精準控制影片創作工具',
        pageDescription:
            '體驗WeryAI Werydance 2.0 AI影片生成器，支援多模態參考輸入、導演級指令遵循、長鏡頭敘事一致性和物理規律模擬。在WeryAI平台免費試用。',
        pageKeywords:
            'Werydance 2.0, WeryAI, 即夢AI, AI影片生成器, 導演級控制, 多模態影片, 物理模擬, 口型同步, 文生影片, 圖生影片, 免費AI影片, WeryAI',
        generatorTitle: 'Werydance 2.0 影片生成器',
        generatorDescription:
            'WeryAI 推出了 <span class="text-text-active">Werydance 2.0</span>，這是一款旗艦級AI影片生成模型，透過強大的語義理解和物理規律模擬，實現了「指令即所得」的導演級精準控制。現已在 <span class="text-text-active">WeryAI 影片生成器上可用，點擊此處免費試用</span>！',
        tabImageToVideo: '圖片轉影片',
        tabTextToVideo: '文字轉影片',
        coreFeaturesTitle: 'Werydance 2.0 的核心功能',
        multiModalReferenceTitle: '全能多模態參考',
        multiModalReferenceDescription:
            '突破單一輸入的限制，支援圖像、影片、音訊的混合輸入。模型能精準提取各參考源的特徵並完美融合。',
        directorLevelControlTitle: '導演級指令遵循',
        directorLevelControlDescription:
            '解決了AI影片「聽不懂人話」的痛點。Werydance 2.0能一次性理解並執行複雜的複合指令，大幅降低廢片率。',
        narrativeConsistencyTitle: '長鏡頭與敘事一致性',
        narrativeConsistencyDescription:
            '在生成多鏡頭或續集影片時，模型能保持極高的人物和場景一致性，可製作包含對話、劇情推進的連續短劇。',
        physicsVFXTitle: '物理規律與特效模擬',
        physicsVFXDescription:
            '攻克了AI影片常見的「物理幻覺」問題，在處理複雜場景時展現對真實物理世界的深刻理解。',
        howToUseTitle: '如何使用',
        howToUseSubtitle: '簡單三步，開始創作',
        step1Title: '選擇 Werydance 2.0 模型',
        step1Description:
            '前往<span class="highlight-text">「圖片轉影片AI」</span>頁面，在模型下拉選單中點擊「Werydance 2.0」。',
        step2Title: '輸入提示詞，調整參數',
        step2Description: '描述您想要的畫面或上傳圖片，設定影片時長、比例，並選擇是否開啟「音畫同步」功能。',
        step3Title: '生成與下載',
        step3Description: '點擊「生成」，等待導演級大片渲染完成，即可下載或分享。',
        youtubeTitle: '關於 Werydance 2.0 影片模型的 YouTube 影片',
        xPostsTitle: '關於 Werydance 2.0 影片模型的 X 貼文',
        exploreModelsTitle: '探索其他模型',
        veo31Title: 'Google Veo 3.1 AI 影片生成器',
        klingTitle: 'Kling AI 影片生成器',
        weryaiVideoTitle: 'WeryAI Video 1.0 生成器',
        faqTitle: '常見問題解答',
        ctaTitle: '準備開始創作了嗎？',
        ctaDescription: '立即體驗 Werydance 2.0，將您的創意轉化為導演級大片',
        ctaButton: '在WeryAI上試用Werydance 2.0',
        ctaDisclaimer: '無需信用卡',
        pageDisclaimer:
            '免責聲明：WeryAI 是一個獨立運營的產品/平台，與字節跳動（ByteDance）及 Seedance 沒有任何關聯，也未獲得其認可、授權或贊助。我們僅透過客製化介面及 API 技術，為用戶提供便捷存取與使用 Seedance 2.0 模型的途徑。',
    },
    es: {
        pageTitle: 'Werydance 2.0 Generador de Video AI - Herramienta de Creación con Control de Director',
        pageDescription:
            'Experimenta el generador de video AI Werydance 2.0 de WeryAI con entradas de referencia multimodal, seguimiento de instrucciones a nivel de director y simulación de física. Pruébalo gratis en WeryAI.',
        pageKeywords:
            'Werydance 2.0, Seedance AI, WeryAI, generador de video AI, video nivel director, video multimodal, simulación física, sincronización labial, texto a video, video AI gratis, WeryAI',
        generatorTitle: 'Generador de Video Werydance 2.0',
        generatorDescription:
            'WeryAI lanzó <span class="text-text-active">Werydance 2.0</span>, un modelo insignia de generación de video AI que logra un control preciso a nivel de director. <span class="text-text-active">Disponible en el generador de video WeryAI, ¡pruébalo gratis</span>!',
        tabImageToVideo: 'Imagen a Video',
        tabTextToVideo: 'Texto a Video',
        coreFeaturesTitle: 'Características Principales de Werydance 2.0',
        multiModalReferenceTitle: 'Referencia Multimodal',
        multiModalReferenceDescription: 'Soporta entradas mixtas de imágenes, videos y audio. El modelo extrae características de cada fuente y las fusiona perfectamente.',
        directorLevelControlTitle: 'Control a Nivel de Director',
        directorLevelControlDescription: 'Comprende y ejecuta instrucciones compuestas complejas en un solo paso, reduciendo drásticamente las salidas descartadas.',
        narrativeConsistencyTitle: 'Consistencia Narrativa en Toma Larga',
        narrativeConsistencyDescription: 'Mantiene una consistencia extremadamente alta de personajes y escenas al generar videos de múltiples tomas o secuelas.',
        physicsVFXTitle: 'Simulación de Física y VFX',
        physicsVFXDescription: 'Supera el problema de "alucinación física" con movimientos fluidos y naturales en escenas complejas.',
        howToUseTitle: 'Cómo Usar',
        howToUseSubtitle: 'Tres pasos sencillos',
        step1Title: 'Selecciona el Modelo Werydance 2.0',
        step1Description: 'Ve a la página <span class="highlight-text">"Imagen a Video AI"</span> y selecciona "Werydance 2.0" en el menú desplegable.',
        step2Title: 'Ingresa el Prompt y Ajusta Configuración',
        step2Description: 'Describe la escena o sube una imagen, configura la duración del video (hasta 15s) y la relación de aspecto.',
        step3Title: 'Genera y Descarga',
        step3Description: 'Haz clic en "Crear" y espera a que tu video de nivel director se renderice. Descarga o comparte libremente.',
        youtubeTitle: 'Videos de YouTube sobre Werydance 2.0',
        xPostsTitle: 'Publicaciones en X sobre Werydance 2.0',
        exploreModelsTitle: 'Explorar Otros Modelos',
        veo31Title: 'Google Veo 3.1 Generador de Video AI',
        klingTitle: 'Kling AI Generador de Video',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generador',
        faqTitle: 'Preguntas Frecuentes',
        ctaTitle: '¿Listo para Empezar a Crear?',
        ctaDescription: 'Prueba Werydance 2.0 ahora y convierte tus ideas en videos de nivel director',
        ctaButton: 'Probar Werydance 2.0 en WeryAI',
        ctaDisclaimer: 'No se requiere tarjeta de crédito',
        pageDisclaimer:
            'Aviso legal: WeryAI es un producto/plataforma operado de forma independiente y no tiene ninguna afiliación con ByteDance ni con Seedance, ni ha recibido su respaldo, autorización o patrocinio. Solo ofrecemos a los usuarios una forma conveniente de acceder y utilizar el modelo Seedance 2.0 mediante una interfaz personalizada y tecnología API.',
    },
    fr: {
        pageTitle: 'Werydance 2.0 Générateur Vidéo AI - Outil de Création avec Contrôle Niveau Réalisateur',
        pageDescription:
            'Découvrez le générateur vidéo AI Werydance 2.0 de WeryAI avec des entrées de référence multimodales, un suivi des instructions niveau réalisateur et une simulation physique. Essayez gratuitement sur WeryAI.',
        pageKeywords:
            'Werydance 2.0, Seedance AI, WeryAI, générateur vidéo AI, vidéo niveau réalisateur, vidéo multimodale, simulation physique, synchronisation labiale, texte en vidéo, vidéo AI gratuit, WeryAI',
        generatorTitle: 'Générateur Vidéo Werydance 2.0',
        generatorDescription:
            'WeryAI a lancé <span class="text-text-active">Werydance 2.0</span>, un modèle phare de génération vidéo AI offrant un contrôle précis de niveau réalisateur. <span class="text-text-active">Disponible sur le générateur vidéo WeryAI, essayez gratuitement</span> !',
        tabImageToVideo: 'Image vers Vidéo',
        tabTextToVideo: 'Texte vers Vidéo',
        coreFeaturesTitle: 'Fonctionnalités Principales de Werydance 2.0',
        multiModalReferenceTitle: 'Référence Multimodale',
        multiModalReferenceDescription: 'Prend en charge les entrées mixtes d\'images, vidéos et audio, extrayant et fusionnant parfaitement les caractéristiques de chaque source.',
        directorLevelControlTitle: 'Contrôle Niveau Réalisateur',
        directorLevelControlDescription: 'Comprend et exécute des instructions composées complexes en une seule fois, réduisant considérablement le taux de résultats inutilisables.',
        narrativeConsistencyTitle: 'Plan-séquence et Cohérence Narrative',
        narrativeConsistencyDescription: 'Maintient une cohérence extrêmement élevée des personnages et des décors lors de la génération de vidéos multi-plans.',
        physicsVFXTitle: 'Simulation Physique et VFX',
        physicsVFXDescription: 'Surmonte le problème d\'"hallucination physique" avec des mouvements fluides et naturels dans les scènes complexes.',
        howToUseTitle: 'Comment Utiliser',
        howToUseSubtitle: 'Trois étapes simples',
        step1Title: 'Sélectionnez le Modèle Werydance 2.0',
        step1Description: 'Allez sur la page <span class="highlight-text">"Image vers Vidéo AI"</span> et cliquez sur "Werydance 2.0" dans le menu déroulant.',
        step2Title: 'Entrez le Prompt et Ajustez les Paramètres',
        step2Description: 'Décrivez la scène souhaitée ou téléchargez une image, définissez la durée (jusqu\'à 15s) et le ratio.',
        step3Title: 'Générez et Téléchargez',
        step3Description: 'Cliquez sur "Créer" et attendez que votre vidéo niveau réalisateur soit rendue.',
        youtubeTitle: 'Vidéos YouTube sur Werydance 2.0',
        xPostsTitle: 'Publications X sur Werydance 2.0',
        exploreModelsTitle: 'Explorer d\'Autres Modèles',
        veo31Title: 'Google Veo 3.1 Générateur Vidéo AI',
        klingTitle: 'Kling AI Générateur Vidéo',
        weryaiVideoTitle: 'WeryAI Video 1.0 Générateur',
        faqTitle: 'Questions Fréquentes',
        ctaTitle: 'Prêt à Commencer à Créer ?',
        ctaDescription: 'Essayez Werydance 2.0 maintenant et transformez vos idées en vidéos de niveau réalisateur',
        ctaButton: 'Essayer Werydance 2.0 sur WeryAI',
        ctaDisclaimer: 'Aucune carte de crédit requise',
        pageDisclaimer:
            'Avertissement : WeryAI est un produit/une plateforme exploité(e) de manière indépendante et n\'a aucun lien avec ByteDance ou Seedance, ni n\'a reçu de leur part une quelconque approbation, autorisation ou un quelconque parrainage. Nous fournissons simplement aux utilisateurs un moyen pratique d\'accéder au modèle Seedance 2.0 et de l\'utiliser via une interface personnalisée et une technologie API.',
    },
    de: {
        pageTitle: 'Werydance 2.0 AI-Videogenerator - Regisseur-Level Kontrolle',
        pageDescription:
            'Erleben Sie den WeryAI Werydance 2.0 AI-Videogenerator mit multimodaler Referenzeingabe, Regisseur-Level Anweisungsbefolgung und Physiksimulation. Kostenlos auf WeryAI testen.',
        pageKeywords:
            'Werydance 2.0, Seedance AI, WeryAI, KI-Videogenerator, Regisseur-Level Video, multimodales Video, Physiksimulation, Lippensynchronisation, Text zu Video, kostenlose KI-Videos, WeryAI',
        generatorTitle: 'Werydance 2.0 Videogenerator',
        generatorDescription:
            'WeryAI hat <span class="text-text-active">Werydance 2.0</span> veröffentlicht, ein Flaggschiff-AI-Videogenerierungsmodell mit Regisseur-Level Präzisionskontrolle. <span class="text-text-active">Jetzt kostenlos auf dem WeryAI Videogenerator verfügbar</span>!',
        tabImageToVideo: 'Bild zu Video',
        tabTextToVideo: 'Text zu Video',
        coreFeaturesTitle: 'Werydance 2.0 Kernfunktionen',
        multiModalReferenceTitle: 'Multimodale Referenz',
        multiModalReferenceDescription: 'Unterstützt gemischte Eingaben von Bildern, Videos und Audio mit präziser Merkmalextraktion und perfekter Fusion.',
        directorLevelControlTitle: 'Regisseur-Level Kontrolle',
        directorLevelControlDescription: 'Versteht und führt komplexe zusammengesetzte Anweisungen in einem Durchgang aus und reduziert Ausschuss drastisch.',
        narrativeConsistencyTitle: 'Plansequenz & Erzählkonsistenz',
        narrativeConsistencyDescription: 'Hält extrem hohe Konsistenz von Charakteren und Szenen bei Multi-Shot-Videos aufrecht.',
        physicsVFXTitle: 'Physik- & VFX-Simulation',
        physicsVFXDescription: 'Überwindet das "Physik-Halluzinations"-Problem mit flüssigen, natürlichen Bewegungen in komplexen Szenen.',
        howToUseTitle: 'Verwendung',
        howToUseSubtitle: 'Drei einfache Schritte',
        step1Title: 'Werydance 2.0 Modell wählen',
        step1Description: 'Gehen Sie zur <span class="highlight-text">"Bild zu Video AI"</span> Seite und wählen Sie "Werydance 2.0" im Dropdown-Menü.',
        step2Title: 'Prompt eingeben & Einstellungen anpassen',
        step2Description: 'Beschreiben Sie die gewünschte Szene oder laden Sie ein Bild hoch, stellen Sie Videodauer (bis 15s) und Seitenverhältnis ein.',
        step3Title: 'Generieren & Herunterladen',
        step3Description: 'Klicken Sie auf "Erstellen" und warten Sie, bis Ihr Regisseur-Level Video gerendert ist.',
        youtubeTitle: 'YouTube-Videos über Werydance 2.0',
        xPostsTitle: 'X-Beiträge über Werydance 2.0',
        exploreModelsTitle: 'Andere Modelle Entdecken',
        veo31Title: 'Google Veo 3.1 AI-Videogenerator',
        klingTitle: 'Kling AI-Videogenerator',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generator',
        faqTitle: 'Häufig Gestellte Fragen',
        ctaTitle: 'Bereit zum Erstellen?',
        ctaDescription: 'Probieren Sie Werydance 2.0 jetzt aus und verwandeln Sie Ihre Ideen in Regisseur-Level Videos',
        ctaButton: 'Werydance 2.0 auf WeryAI testen',
        ctaDisclaimer: 'Keine Kreditkarte erforderlich',
        pageDisclaimer:
            'Haftungsausschluss: WeryAI ist ein unabhängig betriebenes Produkt/eine unabhängig betriebene Plattform und steht in keinerlei Verbindung zu ByteDance oder Seedance. Zudem wurde keine Anerkennung, Genehmigung oder Förderung durch diese erteilt. Wir bieten Nutzern lediglich über eine angepasste Oberfläche und API-Technologie eine bequeme Möglichkeit, auf das Seedance-2.0-Modell zuzugreifen und es zu nutzen.',
    },
    ru: {
        pageTitle: 'Werydance 2.0 AI Генератор Видео - Режиссёрский Уровень Контроля',
        pageDescription:
            'Попробуйте AI генератор видео Werydance 2.0 от WeryAI с мультимодальными входами, следованием инструкциям уровня режиссёра и симуляцией физики. Бесплатно на WeryAI.',
        pageKeywords:
            'Werydance 2.0, Seedance AI, WeryAI, ИИ генератор видео, режиссёрское видео, мультимодальное видео, физическая симуляция, синхронизация губ, текст в видео, бесплатное ИИ видео, WeryAI',
        generatorTitle: 'Генератор Видео Werydance 2.0',
        generatorDescription:
            'WeryAI выпустила <span class="text-text-active">Werydance 2.0</span> — флагманскую модель генерации AI-видео с точным контролем на уровне режиссёра. <span class="text-text-active">Доступно на видеогенераторе WeryAI, попробуйте бесплатно</span>!',
        tabImageToVideo: 'Изображение в видео',
        tabTextToVideo: 'Текст в видео',
        coreFeaturesTitle: 'Основные Возможности Werydance 2.0',
        multiModalReferenceTitle: 'Мультимодальная Референция',
        multiModalReferenceDescription: 'Поддерживает смешанные входы изображений, видео и аудио с точным извлечением и слиянием характеристик каждого источника.',
        directorLevelControlTitle: 'Контроль Уровня Режиссёра',
        directorLevelControlDescription: 'Понимает и выполняет сложные составные инструкции за один раз, значительно сокращая брак.',
        narrativeConsistencyTitle: 'Длинный План и Нарративная Последовательность',
        narrativeConsistencyDescription: 'Поддерживает крайне высокую последовательность персонажей и сцен при генерации многокадрового видео.',
        physicsVFXTitle: 'Симуляция Физики и VFX',
        physicsVFXDescription: 'Преодолевает проблему «физических галлюцинаций» с плавными, естественными движениями в сложных сценах.',
        howToUseTitle: 'Как Использовать',
        howToUseSubtitle: 'Три простых шага',
        step1Title: 'Выберите модель Werydance 2.0',
        step1Description: 'Перейдите на страницу <span class="highlight-text">«Изображение в видео AI»</span> и выберите «Werydance 2.0» в выпадающем меню.',
        step2Title: 'Введите промпт и настройте параметры',
        step2Description: 'Опишите желаемую сцену или загрузите изображение, установите длительность видео (до 15 сек) и соотношение сторон.',
        step3Title: 'Сгенерируйте и скачайте',
        step3Description: 'Нажмите «Создать» и дождитесь рендеринга вашего видео режиссёрского уровня.',
        youtubeTitle: 'Видео на YouTube о Werydance 2.0',
        xPostsTitle: 'Посты в X о Werydance 2.0',
        exploreModelsTitle: 'Другие Модели',
        veo31Title: 'Google Veo 3.1 AI Генератор Видео',
        klingTitle: 'Kling AI Генератор Видео',
        weryaiVideoTitle: 'WeryAI Video 1.0 Генератор',
        faqTitle: 'Часто Задаваемые Вопросы',
        ctaTitle: 'Готовы начать создавать?',
        ctaDescription: 'Попробуйте Werydance 2.0 прямо сейчас',
        ctaButton: 'Попробовать Werydance 2.0 на WeryAI',
        ctaDisclaimer: 'Кредитная карта не требуется',
        pageDisclaimer:
            'Отказ от ответственности: WeryAI является независимо управляемым продуктом/платформой и не имеет никакого отношения к ByteDance и Seedance, а также не получал от них одобрения, разрешения или спонсорской поддержки. Мы лишь предоставляем пользователям удобный способ доступа к модели Seedance 2.0 и её использования через пользовательский интерфейс и API-технологии.',
    },
    pl: {
        pageTitle: 'Werydance 2.0 Generator Wideo AI - Kontrola na Poziomie Reżysera',
        pageDescription: 'Wypróbuj generator wideo AI Werydance 2.0 od WeryAI z multimodalnymi referencjami, kontrolą reżyserską i symulacją fizyki. Za darmo na WeryAI.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, generator wideo AI, wideo reżyserskie, wideo multimodalne, symulacja fizyki, synchronizacja ust, tekst na wideo, darmowe wideo AI, WeryAI',
        generatorTitle: 'Generator Wideo Werydance 2.0',
        generatorDescription: 'WeryAI wydało <span class="text-text-active">Werydance 2.0</span>, flagowy model generowania wideo AI z precyzyjną kontrolą na poziomie reżysera. <span class="text-text-active">Dostępny na generatorze wideo WeryAI, wypróbuj za darmo</span>!',
        tabImageToVideo: 'Obraz na wideo',
        tabTextToVideo: 'Tekst na wideo',
        coreFeaturesTitle: 'Główne Funkcje Werydance 2.0',
        multiModalReferenceTitle: 'Referencia Multimodalna',
        multiModalReferenceDescription: 'Obsługuje mieszane dane wejściowe obrazów, wideo i audio z precyzyjną ekstrakcją i fuzją cech.',
        directorLevelControlTitle: 'Kontrola na Poziomie Reżysera',
        directorLevelControlDescription: 'Rozumie i wykonuje złożone instrukcje złożone za jednym razem, drastycznie redukując odrzuty.',
        narrativeConsistencyTitle: 'Długie Ujęcie i Spójność Narracyjna',
        narrativeConsistencyDescription: 'Utrzymuje niezwykle wysoką spójność postaci i scen w materiałach wieloujęciowych.',
        physicsVFXTitle: 'Symulacja Fizyki i VFX',
        physicsVFXDescription: 'Pokonuje problem "halucynacji fizycznych" z płynnymi, naturalnymi ruchami w złożonych scenach.',
        howToUseTitle: 'Jak Używać',
        howToUseSubtitle: 'Trzy proste kroki',
        step1Title: 'Wybierz model Werydance 2.0',
        step1Description: 'Przejdź na stronę <span class="highlight-text">"Obraz na wideo AI"</span> i wybierz "Werydance 2.0" z menu rozwijanego.',
        step2Title: 'Wpisz prompt i dostosuj ustawienia',
        step2Description: 'Opisz scenę lub prześlij obraz, ustaw czas trwania wideo (do 15s) i proporcje.',
        step3Title: 'Generuj i pobierz',
        step3Description: 'Kliknij "Utwórz" i czekaj na renderowanie wideo na poziomie reżyserskim.',
        youtubeTitle: 'Filmy YouTube o Werydance 2.0',
        xPostsTitle: 'Posty X o Werydance 2.0',
        exploreModelsTitle: 'Odkryj Inne Modele',
        veo31Title: 'Google Veo 3.1 Generator Wideo AI',
        klingTitle: 'Kling AI Generator Wideo',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generator',
        faqTitle: 'Często Zadawane Pytania',
        ctaTitle: 'Gotowy do Tworzenia?',
        ctaDescription: 'Wypróbuj Werydance 2.0 i zamień swoje pomysły w filmy na poziomie reżyserskim',
        ctaButton: 'Wypróbuj Werydance 2.0 na WeryAI',
        ctaDisclaimer: 'Karta kredytowa nie jest wymagana',
        pageDisclaimer:
            'Zastrzeżenie: WeryAI jest niezależnie prowadzonym produktem/platformą i nie ma żadnych powiązań z ByteDance ani Seedance, ani nie otrzymało od nich aprobaty, autoryzacji czy sponsoringu. Zapewniamy jedynie użytkownikom wygodny sposób dostępu do modelu Seedance 2.0 i korzystania z niego za pośrednictwem niestandardowego interfejsu oraz technologii API.',
    },
    pt: {
        pageTitle: 'Werydance 2.0 Gerador de Vídeo AI - Controle Nível Diretor',
        pageDescription: 'Experimente o gerador de vídeo AI Werydance 2.0 da WeryAI com entradas de referência multimodal, controle nível diretor e simulação de física. Grátis no WeryAI.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, gerador de vídeo AI, vídeo nível diretor, vídeo multimodal, simulação física, sincronização labial, texto para vídeo, vídeo AI grátis, WeryAI',
        generatorTitle: 'Gerador de Vídeo Werydance 2.0',
        generatorDescription: 'A WeryAI lançou o <span class="text-text-active">Werydance 2.0</span>, um modelo flagship de geração de vídeo AI com controle preciso nível diretor. <span class="text-text-active">Disponível no gerador de vídeo WeryAI, experimente grátis</span>!',
        tabImageToVideo: 'Imagem para Vídeo',
        tabTextToVideo: 'Texto para Vídeo',
        coreFeaturesTitle: 'Recursos Principais do Werydance 2.0',
        multiModalReferenceTitle: 'Referência Multimodal',
        multiModalReferenceDescription: 'Suporta entradas mistas de imagens, vídeos e áudio com extração e fusão perfeita de características.',
        directorLevelControlTitle: 'Controle Nível Diretor',
        directorLevelControlDescription: 'Compreende e executa instruções compostas complexas de uma vez, reduzindo drasticamente resultados descartados.',
        narrativeConsistencyTitle: 'Plano-sequência e Consistência Narrativa',
        narrativeConsistencyDescription: 'Mantém consistência extremamente alta de personagens e cenas em vídeos multi-tomada.',
        physicsVFXTitle: 'Simulação de Física e VFX',
        physicsVFXDescription: 'Supera o problema de "alucinação física" com movimentos fluidos e naturais em cenas complexas.',
        howToUseTitle: 'Como Usar',
        howToUseSubtitle: 'Três passos simples',
        step1Title: 'Selecione o Modelo Werydance 2.0',
        step1Description: 'Vá para a página <span class="highlight-text">"Imagem para Vídeo AI"</span> e selecione "Werydance 2.0" no menu suspenso.',
        step2Title: 'Insira o Prompt e Ajuste as Configurações',
        step2Description: 'Descreva a cena desejada ou envie uma imagem, defina a duração (até 15s) e proporção do vídeo.',
        step3Title: 'Gere e Baixe',
        step3Description: 'Clique em "Criar" e aguarde seu vídeo nível diretor ser renderizado.',
        youtubeTitle: 'Vídeos do YouTube sobre Werydance 2.0',
        xPostsTitle: 'Posts no X sobre Werydance 2.0',
        exploreModelsTitle: 'Explorar Outros Modelos',
        veo31Title: 'Google Veo 3.1 Gerador de Vídeo AI',
        klingTitle: 'Kling AI Gerador de Vídeo',
        weryaiVideoTitle: 'WeryAI Video 1.0 Gerador',
        faqTitle: 'Perguntas Frequentes',
        ctaTitle: 'Pronto para Começar a Criar?',
        ctaDescription: 'Experimente o Werydance 2.0 agora e transforme suas ideias em vídeos nível diretor',
        ctaButton: 'Experimentar Werydance 2.0 no WeryAI',
        ctaDisclaimer: 'Cartão de crédito não necessário',
        pageDisclaimer:
            'Aviso legal: WeryAI é um produto/plataforma operado de forma independente e não possui qualquer afiliação com a ByteDance ou o Seedance, nem recebeu deles endosso, autorização ou patrocínio. Apenas oferecemos aos usuários uma forma conveniente de acessar e utilizar o modelo Seedance 2.0 por meio de uma interface personalizada e tecnologia de API.',
    },
    it: {
        pageTitle: 'Werydance 2.0 Generatore Video AI - Controllo a Livello Regista',
        pageDescription: 'Prova il generatore video AI Werydance 2.0 di WeryAI con input di riferimento multimodali, controllo a livello regista e simulazione fisica. Gratis su WeryAI.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, generatore video AI, video livello regista, video multimodale, simulazione fisica, sincronizzazione labiale, testo a video, video AI gratis, WeryAI',
        generatorTitle: 'Generatore Video Werydance 2.0',
        generatorDescription: 'WeryAI ha lanciato <span class="text-text-active">Werydance 2.0</span>, un modello flagship di generazione video AI con controllo preciso a livello regista. <span class="text-text-active">Disponibile sul generatore video WeryAI, provalo gratis</span>!',
        tabImageToVideo: 'Immagine a Video',
        tabTextToVideo: 'Testo a Video',
        coreFeaturesTitle: 'Funzionalità Principali di Werydance 2.0',
        multiModalReferenceTitle: 'Riferimento Multimodale',
        multiModalReferenceDescription: 'Supporta input misti di immagini, video e audio con estrazione e fusione perfetta delle caratteristiche.',
        directorLevelControlTitle: 'Controllo a Livello Regista',
        directorLevelControlDescription: 'Comprende ed esegue istruzioni composte complesse in un solo passaggio, riducendo drasticamente gli scarti.',
        narrativeConsistencyTitle: 'Piano Sequenza e Coerenza Narrativa',
        narrativeConsistencyDescription: 'Mantiene una coerenza estremamente elevata di personaggi e scene nei video multi-inquadratura.',
        physicsVFXTitle: 'Simulazione Fisica e VFX',
        physicsVFXDescription: 'Supera il problema delle "allucinazioni fisiche" con movimenti fluidi e naturali in scene complesse.',
        howToUseTitle: 'Come Usare',
        howToUseSubtitle: 'Tre semplici passaggi',
        step1Title: 'Seleziona il Modello Werydance 2.0',
        step1Description: 'Vai alla pagina <span class="highlight-text">"Immagine a Video AI"</span> e seleziona "Werydance 2.0" dal menu a tendina.',
        step2Title: 'Inserisci il Prompt e Regola le Impostazioni',
        step2Description: 'Descrivi la scena desiderata o carica un\'immagine, imposta la durata (fino a 15s) e il rapporto.',
        step3Title: 'Genera e Scarica',
        step3Description: 'Clicca "Crea" e attendi il rendering del tuo video a livello regista.',
        youtubeTitle: 'Video YouTube su Werydance 2.0',
        xPostsTitle: 'Post X su Werydance 2.0',
        exploreModelsTitle: 'Esplora Altri Modelli',
        veo31Title: 'Google Veo 3.1 Generatore Video AI',
        klingTitle: 'Kling AI Generatore Video',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generatore',
        faqTitle: 'Domande Frequenti',
        ctaTitle: 'Pronto a Iniziare a Creare?',
        ctaDescription: 'Prova Werydance 2.0 ora e trasforma le tue idee in video a livello regista',
        ctaButton: 'Prova Werydance 2.0 su WeryAI',
        ctaDisclaimer: 'Nessuna carta di credito richiesta',
        pageDisclaimer:
            'Dichiarazione di non responsabilità: WeryAI è un prodotto/una piattaforma gestita in modo indipendente e non ha alcuna affiliazione con ByteDance o Seedance, né ha ricevuto da loro approvazione, autorizzazione o sponsorizzazione. Forniamo semplicemente agli utenti un modo pratico per accedere e utilizzare il modello Seedance 2.0 tramite un\'interfaccia personalizzata e la tecnologia API.',
    },
    ar: {
        pageTitle: 'Werydance 2.0 مولد فيديو AI - تحكم على مستوى المخرج',
        pageDescription: 'جرب مولد فيديو AI Werydance 2.0 من WeryAI مع مدخلات مرجعية متعددة الوسائط وتحكم على مستوى المخرج. مجاناً على WeryAI.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, مولد فيديو AI, فيديو مستوى المخرج, فيديو متعدد الوسائط, محاكاة فيزيائية, مزامنة شفاه, نص إلى فيديو, فيديو AI مجاني, WeryAI',
        generatorTitle: 'مولد فيديو Werydance 2.0',
        generatorDescription: 'أطلقت WeryAI <span class="text-text-active">Werydance 2.0</span>، نموذج رائد لتوليد فيديو AI بتحكم دقيق على مستوى المخرج. <span class="text-text-active">متاح على مولد فيديو WeryAI، جربه مجاناً</span>!',
        tabImageToVideo: 'صورة إلى فيديو',
        tabTextToVideo: 'نص إلى فيديو',
        coreFeaturesTitle: 'الميزات الأساسية لـ Werydance 2.0',
        multiModalReferenceTitle: 'المرجع متعدد الوسائط',
        multiModalReferenceDescription: 'يدعم المدخلات المختلطة من الصور والفيديو والصوت مع استخراج ودمج دقيق للميزات.',
        directorLevelControlTitle: 'تحكم على مستوى المخرج',
        directorLevelControlDescription: 'يفهم وينفذ التعليمات المركبة المعقدة دفعة واحدة، مما يقلل بشكل كبير من المخرجات المهدرة.',
        narrativeConsistencyTitle: 'لقطة طويلة واتساق سردي',
        narrativeConsistencyDescription: 'يحافظ على اتساق عالٍ للغاية للشخصيات والمشاهد عبر مقاطع فيديو متعددة اللقطات.',
        physicsVFXTitle: 'محاكاة الفيزياء والمؤثرات البصرية',
        physicsVFXDescription: 'يتغلب على مشكلة "الهلوسة الفيزيائية" بحركات سلسة وطبيعية في المشاهد المعقدة.',
        howToUseTitle: 'كيفية الاستخدام',
        howToUseSubtitle: 'ثلاث خطوات بسيطة',
        step1Title: 'اختر نموذج Werydance 2.0',
        step1Description: 'انتقل إلى صفحة <span class="highlight-text">"صورة إلى فيديو AI"</span> واختر "Werydance 2.0" من القائمة المنسدلة.',
        step2Title: 'أدخل الوصف واضبط الإعدادات',
        step2Description: 'صف المشهد المطلوب أو ارفع صورة، واضبط مدة الفيديو (حتى 15 ثانية) والنسبة.',
        step3Title: 'أنشئ وحمّل',
        step3Description: 'انقر "إنشاء" وانتظر حتى يتم تقديم الفيديو بمستوى المخرج.',
        youtubeTitle: 'فيديوهات يوتيوب عن Werydance 2.0',
        xPostsTitle: 'منشورات X عن Werydance 2.0',
        exploreModelsTitle: 'استكشف نماذج أخرى',
        veo31Title: 'Google Veo 3.1 مولد فيديو AI',
        klingTitle: 'Kling AI مولد فيديو',
        weryaiVideoTitle: 'WeryAI Video 1.0 مولد',
        faqTitle: 'الأسئلة الشائعة',
        ctaTitle: 'مستعد لبدء الإبداع؟',
        ctaDescription: 'جرب Werydance 2.0 الآن وحول أفكارك إلى فيديوهات بمستوى المخرج',
        ctaButton: 'جرب Werydance 2.0 على WeryAI',
        ctaDisclaimer: 'لا حاجة لبطاقة ائتمان',
        pageDisclaimer:
            'إخلاء مسؤولية: WeryAI هو منتج/منصة تُدار بشكل مستقل ولا تربطه أي علاقة بـ ByteDance أو Seedance، كما أنه لم يحصل على أي اعتماد أو تفويض أو رعاية منهما. نحن فقط نوفر للمستخدمين طريقة مريحة للوصول إلى نموذج Seedance 2.0 واستخدامه من خلال واجهة مخصصة وتقنية API.',
    },
    th: {
        pageTitle: 'Werydance 2.0 เครื่องมือสร้างวิดีโอ AI - การควบคุมระดับผู้กำกับ',
        pageDescription: 'สัมผัส Werydance 2.0 AI จาก WeryAI พร้อมอินพุตอ้างอิงหลายรูปแบบ การควบคุมระดับผู้กำกับ และการจำลองฟิสิกส์ ทดลองฟรีบน WeryAI',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, ตัวสร้างวิดีโอ AI, วิดีโอระดับผู้กำกับ, วิดีโอหลายรูปแบบ, จำลองฟิสิกส์, ซิงค์ริมฝีปาก, ข้อความเป็นวิดีโอ, วิดีโอ AI ฟรี, WeryAI',
        generatorTitle: 'เครื่องสร้างวิดีโอ Werydance 2.0',
        generatorDescription: 'WeryAI เปิดตัว <span class="text-text-active">Werydance 2.0</span> โมเดลสร้างวิดีโอ AI ระดับเรือธงพร้อมการควบคุมที่แม่นยำระดับผู้กำกับ <span class="text-text-active">ใช้งานได้แล้วบน WeryAI ทดลองฟรี</span>!',
        tabImageToVideo: 'รูปภาพเป็นวิดีโอ',
        tabTextToVideo: 'ข้อความเป็นวิดีโอ',
        coreFeaturesTitle: 'คุณสมบัติหลักของ Werydance 2.0',
        multiModalReferenceTitle: 'การอ้างอิงหลายรูปแบบ',
        multiModalReferenceDescription: 'รองรับอินพุตแบบผสมของภาพ วิดีโอ และเสียง พร้อมการแยกและรวมคุณลักษณะอย่างแม่นยำ',
        directorLevelControlTitle: 'การควบคุมระดับผู้กำกับ',
        directorLevelControlDescription: 'เข้าใจและดำเนินการคำสั่งที่ซับซ้อนได้ในครั้งเดียว ลดผลลัพธ์ที่ไม่ต้องการอย่างมาก',
        narrativeConsistencyTitle: 'ช็อตยาวและความสอดคล้องของเรื่องราว',
        narrativeConsistencyDescription: 'รักษาความสอดคล้องของตัวละครและฉากอย่างสูงในวิดีโอหลายช็อต',
        physicsVFXTitle: 'การจำลองฟิสิกส์และ VFX',
        physicsVFXDescription: 'เอาชนะปัญหา "ภาพหลอนทางฟิสิกส์" ด้วยการเคลื่อนไหวที่ลื่นไหลและเป็นธรรมชาติ',
        howToUseTitle: 'วิธีใช้งาน',
        howToUseSubtitle: 'สามขั้นตอนง่ายๆ',
        step1Title: 'เลือกโมเดล Werydance 2.0',
        step1Description: 'ไปที่หน้า <span class="highlight-text">"รูปภาพเป็นวิดีโอ AI"</span> แล้วเลือก "Werydance 2.0" จากเมนูดรอปดาวน์',
        step2Title: 'ใส่คำอธิบายและปรับการตั้งค่า',
        step2Description: 'อธิบายฉากที่ต้องการหรืออัปโหลดภาพ ตั้งค่าความยาววิดีโอ (สูงสุด 15 วินาที) และอัตราส่วน',
        step3Title: 'สร้างและดาวน์โหลด',
        step3Description: 'คลิก "สร้าง" และรอให้วิดีโอระดับผู้กำกับของคุณเรนเดอร์เสร็จ',
        youtubeTitle: 'วิดีโอ YouTube เกี่ยวกับ Werydance 2.0',
        xPostsTitle: 'โพสต์ X เกี่ยวกับ Werydance 2.0',
        exploreModelsTitle: 'สำรวจโมเดลอื่นๆ',
        veo31Title: 'Google Veo 3.1 เครื่องสร้างวิดีโอ AI',
        klingTitle: 'Kling AI เครื่องสร้างวิดีโอ',
        weryaiVideoTitle: 'WeryAI Video 1.0 เครื่องสร้าง',
        faqTitle: 'คำถามที่พบบ่อย',
        ctaTitle: 'พร้อมเริ่มสร้างสรรค์แล้วหรือยัง?',
        ctaDescription: 'ลอง Werydance 2.0 ตอนนี้และเปลี่ยนไอเดียของคุณเป็นวิดีโอระดับผู้กำกับ',
        ctaButton: 'ลอง Werydance 2.0 บน WeryAI',
        ctaDisclaimer: 'ไม่ต้องใช้บัตรเครดิต',
        pageDisclaimer:
            'ข้อสงวนสิทธิ์: WeryAI เป็นผลิตภัณฑ์/แพลตฟอร์มที่ดำเนินงานอย่างอิสระ และไม่มีความเกี่ยวข้องใด ๆ กับ ByteDance หรือ Seedance รวมถึงไม่ได้รับการรับรอง อนุญาต หรือสนับสนุนจากพวกเขา เราเพียงมอบวิธีที่สะดวกให้ผู้ใช้เข้าถึงและใช้งานโมเดล Seedance 2.0 ผ่านอินเทอร์เฟซที่ปรับแต่งเองและเทคโนโลยี API เท่านั้น',
    },
    da: {
        pageTitle: 'Werydance 2.0 AI Videogenerator - Instruktørniveau Kontrol',
        pageDescription: 'Oplev WeryAI Werydance 2.0 AI videogenerator med multimodale referencer, instruktørniveau kontrol og fysiksimulering. Prøv gratis på WeryAI.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, AI videogenerator, instruktørniveau video, multimodal video, fysiksimulering, læbesynkronisering, tekst til video, gratis AI video, WeryAI',
        generatorTitle: 'Werydance 2.0 Videogenerator',
        generatorDescription: 'WeryAI har lanceret <span class="text-text-active">Werydance 2.0</span>, en flagskibs AI-videogenereringsmodel med præcis instruktørniveau kontrol. <span class="text-text-active">Tilgængelig på WeryAI videogenerator, prøv gratis</span>!',
        tabImageToVideo: 'Billede til Video',
        tabTextToVideo: 'Tekst til Video',
        coreFeaturesTitle: 'Werydance 2.0 Kernefunktioner',
        multiModalReferenceTitle: 'Multimodal Reference',
        multiModalReferenceDescription: 'Understøtter blandede input af billeder, video og lyd med præcis udtræk og fusion af funktioner.',
        directorLevelControlTitle: 'Instruktørniveau Kontrol',
        directorLevelControlDescription: 'Forstår og udfører komplekse sammenæstte instruktioner på én gang.',
        narrativeConsistencyTitle: 'Lang Indstilling & Narrativ Konsistens',
        narrativeConsistencyDescription: 'Opretholder ekstremt høj karakter- og scenekonsistens på tværs af multi-shot videoer.',
        physicsVFXTitle: 'Fysik & VFX Simulering',
        physicsVFXDescription: 'Overvinder "fysikhallucinations"-problemet med flydende, naturlige bevægelser.',
        howToUseTitle: 'Sådan Bruges Det',
        howToUseSubtitle: 'Tre enkle trin',
        step1Title: 'Vælg Werydance 2.0 Model',
        step1Description: 'Gå til <span class="highlight-text">"Billede til Video AI"</span> siden og vælg "Werydance 2.0" fra rullemenuen.',
        step2Title: 'Indtast Prompt og Juster Indstillinger',
        step2Description: 'Beskriv scenen eller upload et billede, indstil videovarighed (op til 15s) og billedformat.',
        step3Title: 'Generer og Download',
        step3Description: 'Klik "Opret" og vent på din instruktørniveau video.',
        youtubeTitle: 'YouTube Videoer om Werydance 2.0',
        xPostsTitle: 'X Opslag om Werydance 2.0',
        exploreModelsTitle: 'Udforsk Andre Modeller',
        veo31Title: 'Google Veo 3.1 AI Videogenerator',
        klingTitle: 'Kling AI Videogenerator',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generator',
        faqTitle: 'Ofte Stillede Spørgsmål',
        ctaTitle: 'Klar til at Begynde at Skabe?',
        ctaDescription: 'Prøv Werydance 2.0 nu og forvandl dine idéer til instruktørniveau videoer',
        ctaButton: 'Prøv Werydance 2.0 på WeryAI',
        ctaDisclaimer: 'Intet kreditkort påkrævet',
        pageDisclaimer:
            'Ansvarsfraskrivelse: WeryAI er et uafhængigt drevet produkt/en platform og har ingen tilknytning til ByteDance eller Seedance, og har heller ikke modtaget nogen godkendelse, autorisation eller sponsorering fra dem. Vi tilbyder blot brugerne en praktisk måde at få adgang til og bruge Seedance 2.0-modellen via en tilpasset grænseflade og API-teknologi.',
    },
    no: {
        pageTitle: 'Werydance 2.0 AI Videogenerator - Regissørnivå Kontroll',
        pageDescription: 'Opplev WeryAI Werydance 2.0 AI videogenerator med multimodale referanser, regissørnivå kontroll og fysikksimulering. Prøv gratis på WeryAI.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, AI videogenerator, regissørnivå video, multimodal video, fysikksimulering, leppesynkronisering, tekst til video, gratis AI video, WeryAI',
        generatorTitle: 'Werydance 2.0 Videogenerator',
        generatorDescription: 'WeryAI har lansert <span class="text-text-active">Werydance 2.0</span>, en flaggskip AI-videogenereringsmodell med presis regissørnivå kontroll. <span class="text-text-active">Tilgjengelig på WeryAI videogenerator, prøv gratis</span>!',
        tabImageToVideo: 'Bilde til Video',
        tabTextToVideo: 'Tekst til Video',
        coreFeaturesTitle: 'Werydance 2.0 Kjernefunksjoner',
        multiModalReferenceTitle: 'Multimodal Referanse',
        multiModalReferenceDescription: 'Støtter blandede inndata fra bilder, video og lyd med nøyaktig uttrekking og fusjon av funksjoner.',
        directorLevelControlTitle: 'Regissørnivå Kontroll',
        directorLevelControlDescription: 'Forstår og utfører komplekse sammensatte instruksjoner på én gang.',
        narrativeConsistencyTitle: 'Lang Innstilling & Narrativ Konsistens',
        narrativeConsistencyDescription: 'Opprettholder ekstremt høy karakter- og scenekonsistens på tvers av multi-shot videoer.',
        physicsVFXTitle: 'Fysikk & VFX Simulering',
        physicsVFXDescription: 'Overvinner "fysikkhallusinasjons"-problemet med flytende, naturlige bevegelser.',
        howToUseTitle: 'Slik Bruker Du Det',
        howToUseSubtitle: 'Tre enkle trinn',
        step1Title: 'Velg Werydance 2.0 Modell',
        step1Description: 'Gå til <span class="highlight-text">"Bilde til Video AI"</span> siden og velg "Werydance 2.0" fra nedtrekksmenyen.',
        step2Title: 'Skriv inn Prompt og Juster Innstillinger',
        step2Description: 'Beskriv scenen eller last opp et bilde, sett videovarighet (opptil 15s) og sideforhold.',
        step3Title: 'Generer og Last Ned',
        step3Description: 'Klikk "Opprett" og vent på din regissørnivå video.',
        youtubeTitle: 'YouTube Videoer om Werydance 2.0',
        xPostsTitle: 'X Innlegg om Werydance 2.0',
        exploreModelsTitle: 'Utforsk Andre Modeller',
        veo31Title: 'Google Veo 3.1 AI Videogenerator',
        klingTitle: 'Kling AI Videogenerator',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generator',
        faqTitle: 'Ofte Stilte Spørsmål',
        ctaTitle: 'Klar til å Begynne å Skape?',
        ctaDescription: 'Prøv Werydance 2.0 nå og forvandle ideene dine til regissørnivå videoer',
        ctaButton: 'Prøv Werydance 2.0 på WeryAI',
        ctaDisclaimer: 'Ingen kredittkort nødvendig',
        pageDisclaimer:
            'Ansvarsfraskrivelse: WeryAI er et uavhengig drevet produkt/en plattform og har ingen tilknytning til ByteDance eller Seedance, og har heller ikke mottatt noen godkjenning, autorisasjon eller sponsing fra dem. Vi tilbyr kun brukerne en praktisk måte å få tilgang til og bruke Seedance 2.0-modellen gjennom et tilpasset grensesnitt og API-teknologi.',
    },
    nl: {
        pageTitle: 'Werydance 2.0 AI Videogenerator - Regisseursniveau Controle',
        pageDescription: 'Ervaar de WeryAI Werydance 2.0 AI videogenerator met multimodale referentie-invoer, regisseursniveau controle en fysicasimulatie. Gratis op WeryAI.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, AI videogenerator, regisseursniveau video, multimodale video, fysicasimulatie, lipsynchronisatie, tekst naar video, gratis AI video, WeryAI',
        generatorTitle: 'Werydance 2.0 Videogenerator',
        generatorDescription: 'WeryAI heeft <span class="text-text-active">Werydance 2.0</span> gelanceerd, een vlaggenschip AI-videogeneratiemodel met nauwkeurige regisseursniveau controle. <span class="text-text-active">Beschikbaar op de WeryAI videogenerator, probeer gratis</span>!',
        tabImageToVideo: 'Afbeelding naar Video',
        tabTextToVideo: 'Tekst naar Video',
        coreFeaturesTitle: 'Werydance 2.0 Kernfuncties',
        multiModalReferenceTitle: 'Multimodale Referentie',
        multiModalReferenceDescription: 'Ondersteunt gemengde invoer van afbeeldingen, video en audio met nauwkeurige extractie en fusie van kenmerken.',
        directorLevelControlTitle: 'Regisseursniveau Controle',
        directorLevelControlDescription: 'Begrijpt en voert complexe samengestelde instructies in één keer uit.',
        narrativeConsistencyTitle: 'Lange Take & Narratieve Consistentie',
        narrativeConsistencyDescription: 'Handhaaft extreem hoge karakter- en sceneconsistentie over multi-shot video\'s.',
        physicsVFXTitle: 'Fysica & VFX Simulatie',
        physicsVFXDescription: 'Overwint het "fysica-hallucinatie" probleem met vloeiende, natuurlijke bewegingen.',
        howToUseTitle: 'Hoe te Gebruiken',
        howToUseSubtitle: 'Drie eenvoudige stappen',
        step1Title: 'Selecteer Werydance 2.0 Model',
        step1Description: 'Ga naar de <span class="highlight-text">"Afbeelding naar Video AI"</span> pagina en selecteer "Werydance 2.0" uit het dropdown menu.',
        step2Title: 'Voer Prompt in en Pas Instellingen aan',
        step2Description: 'Beschrijf de gewenste scène of upload een afbeelding, stel de videoduur (tot 15s) en beeldverhouding in.',
        step3Title: 'Genereer en Download',
        step3Description: 'Klik op "Aanmaken" en wacht op je regisseursniveau video.',
        youtubeTitle: 'YouTube Video\'s over Werydance 2.0',
        xPostsTitle: 'X Berichten over Werydance 2.0',
        exploreModelsTitle: 'Ontdek Andere Modellen',
        veo31Title: 'Google Veo 3.1 AI Videogenerator',
        klingTitle: 'Kling AI Videogenerator',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generator',
        faqTitle: 'Veelgestelde Vragen',
        ctaTitle: 'Klaar om te Beginnen met Creëren?',
        ctaDescription: 'Probeer Werydance 2.0 nu en verander je ideeën in regisseursniveau video\'s',
        ctaButton: 'Probeer Werydance 2.0 op WeryAI',
        ctaDisclaimer: 'Geen creditcard vereist',
        pageDisclaimer:
            'Disclaimer: WeryAI is een onafhankelijk geëxploiteerd product/platform en heeft geen enkele band met ByteDance of Seedance, en heeft ook geen goedkeuring, autorisatie of sponsoring van hen ontvangen. Wij bieden gebruikers uitsluitend een gemakkelijke manier om via een aangepaste interface en API-technologie toegang te krijgen tot en gebruik te maken van het Seedance 2.0-model.',
    },
    id: {
        pageTitle: 'Werydance 2.0 Generator Video AI - Kontrol Level Sutradara',
        pageDescription: 'Rasakan generator video AI Werydance 2.0 dari WeryAI dengan input referensi multimodal, kontrol level sutradara, dan simulasi fisika. Gratis di WeryAI.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, generator video AI, video level sutradara, video multimodal, simulasi fisika, sinkronisasi bibir, teks ke video, video AI gratis, WeryAI',
        generatorTitle: 'Generator Video Werydance 2.0',
        generatorDescription: 'WeryAI meluncurkan <span class="text-text-active">Werydance 2.0</span>, model flagship generasi video AI dengan kontrol presisi level sutradara. <span class="text-text-active">Tersedia di generator video WeryAI, coba gratis</span>!',
        tabImageToVideo: 'Gambar ke Video',
        tabTextToVideo: 'Teks ke Video',
        coreFeaturesTitle: 'Fitur Utama Werydance 2.0',
        multiModalReferenceTitle: 'Referensi Multimodal',
        multiModalReferenceDescription: 'Mendukung input campuran gambar, video, dan audio dengan ekstraksi dan penggabungan fitur yang presisi.',
        directorLevelControlTitle: 'Kontrol Level Sutradara',
        directorLevelControlDescription: 'Memahami dan menjalankan instruksi komposit kompleks sekaligus, mengurangi output yang terbuang secara drastis.',
        narrativeConsistencyTitle: 'Long Take & Konsistensi Naratif',
        narrativeConsistencyDescription: 'Mempertahankan konsistensi karakter dan adegan yang sangat tinggi di seluruh video multi-shot.',
        physicsVFXTitle: 'Simulasi Fisika & VFX',
        physicsVFXDescription: 'Mengatasi masalah "halusinasi fisika" dengan gerakan yang halus dan alami dalam adegan kompleks.',
        howToUseTitle: 'Cara Menggunakan',
        howToUseSubtitle: 'Tiga langkah sederhana',
        step1Title: 'Pilih Model Werydance 2.0',
        step1Description: 'Buka halaman <span class="highlight-text">"Gambar ke Video AI"</span> dan pilih "Werydance 2.0" dari menu dropdown.',
        step2Title: 'Masukkan Prompt dan Sesuaikan Pengaturan',
        step2Description: 'Deskripsikan adegan yang diinginkan atau unggah gambar, atur durasi video (hingga 15 detik) dan rasio aspek.',
        step3Title: 'Buat dan Unduh',
        step3Description: 'Klik "Buat" dan tunggu video level sutradara Anda selesai di-render.',
        youtubeTitle: 'Video YouTube tentang Werydance 2.0',
        xPostsTitle: 'Postingan X tentang Werydance 2.0',
        exploreModelsTitle: 'Jelajahi Model Lain',
        veo31Title: 'Google Veo 3.1 Generator Video AI',
        klingTitle: 'Kling AI Generator Video',
        weryaiVideoTitle: 'WeryAI Video 1.0 Generator',
        faqTitle: 'Pertanyaan yang Sering Diajukan',
        ctaTitle: 'Siap Mulai Berkreasi?',
        ctaDescription: 'Coba Werydance 2.0 sekarang dan ubah ide Anda menjadi video level sutradara',
        ctaButton: 'Coba Werydance 2.0 di WeryAI',
        ctaDisclaimer: 'Tidak perlu kartu kredit',
        pageDisclaimer:
            'Penafian: WeryAI adalah produk/platform yang dioperasikan secara independen dan tidak memiliki afiliasi apa pun dengan ByteDance maupun Seedance, serta tidak menerima dukungan, otorisasi, atau sponsor dari mereka. Kami hanya menyediakan cara yang nyaman bagi pengguna untuk mengakses dan menggunakan model Seedance 2.0 melalui antarmuka khusus dan teknologi API.',
    },
    tr: {
        pageTitle: 'Werydance 2.0 AI Video Oluşturucu - Yönetmen Seviyesi Kontrol',
        pageDescription: 'WeryAI Werydance 2.0 AI video oluşturucuyu çoklu modal referans girdileri, yönetmen seviyesi kontrol ve fizik simülasyonu ile deneyimleyin. WeryAI\'da ücretsiz deneyin.',
        pageKeywords: 'Werydance 2.0, Seedance AI, WeryAI, AI video oluşturucu, yönetmen seviyesi video, çoklu modal video, fizik simülasyonu, dudak senkronizasyonu, metinden videoya, ücretsiz AI video, WeryAI',
        generatorTitle: 'Werydance 2.0 Video Oluşturucu',
        generatorDescription: 'WeryAI, yönetmen seviyesinde hassas kontrole sahip amiral gemisi AI video oluşturma modeli <span class="text-text-active">Werydance 2.0</span>\'ı yayınladı. <span class="text-text-active">WeryAI video oluşturucuda mevcut, ücretsiz deneyin</span>!',
        tabImageToVideo: 'Görüntüden Videoya',
        tabTextToVideo: 'Metinden Videoya',
        coreFeaturesTitle: 'Werydance 2.0 Temel Özellikler',
        multiModalReferenceTitle: 'Çoklu Modal Referans',
        multiModalReferenceDescription: 'Görüntü, video ve ses karışık girdilerini hassas özellik çıkarma ve birleştirme ile destekler.',
        directorLevelControlTitle: 'Yönetmen Seviyesi Kontrol',
        directorLevelControlDescription: 'Karmaşık bileşik talimatları tek seferde anlayıp yürüterek israf edilen çıktıları büyük ölçüde azaltır.',
        narrativeConsistencyTitle: 'Uzun Çekim ve Anlatı Tutarlılığı',
        narrativeConsistencyDescription: 'Çoklu çekim videolarda son derece yüksek karakter ve sahne tutarlılığını korur.',
        physicsVFXTitle: 'Fizik ve VFX Simülasyonu',
        physicsVFXDescription: 'Karmaşık sahnelerde akıcı, doğal hareketlerle "fizik halüsinasyonu" sorununu aşar.',
        howToUseTitle: 'Nasıl Kullanılır',
        howToUseSubtitle: 'Üç basit adım',
        step1Title: 'Werydance 2.0 Modelini Seçin',
        step1Description: '<span class="highlight-text">"Görüntüden Videoya AI"</span> sayfasına gidin ve açılır menüden "Werydance 2.0"\'ı seçin.',
        step2Title: 'Prompt Girin ve Ayarları Düzenleyin',
        step2Description: 'İstediğiniz sahneyi tanımlayın veya bir görüntü yükleyin, video süresini (15 saniyeye kadar) ve en-boy oranını ayarlayın.',
        step3Title: 'Oluşturun ve İndirin',
        step3Description: '"Oluştur"a tıklayın ve yönetmen seviyesi videonuzun render edilmesini bekleyin.',
        youtubeTitle: 'Werydance 2.0 Hakkında YouTube Videoları',
        xPostsTitle: 'Werydance 2.0 Hakkında X Gönderileri',
        exploreModelsTitle: 'Diğer Modelleri Keşfedin',
        veo31Title: 'Google Veo 3.1 AI Video Oluşturucu',
        klingTitle: 'Kling AI Video Oluşturucu',
        weryaiVideoTitle: 'WeryAI Video 1.0 Oluşturucu',
        faqTitle: 'Sıkça Sorulan Sorular',
        ctaTitle: 'Oluşturmaya Başlamaya Hazır mısınız?',
        ctaDescription: 'Werydance 2.0\'ı şimdi deneyin ve fikirlerinizi yönetmen seviyesi videolara dönüştürün',
        ctaButton: 'WeryAI\'da Werydance 2.0\'ı Deneyin',
        ctaDisclaimer: 'Kredi kartı gerekmez',
        pageDisclaimer:
            'Sorumluluk reddi beyanı: WeryAI bağımsız olarak işletilen bir ürün/platformdur ve ByteDance veya Seedance ile herhangi bir bağlantısı yoktur; ayrıca onlardan herhangi bir onay, yetki veya sponsorluk da almamıştır. Biz yalnızca kullanıcılara, özelleştirilmiş bir arayüz ve API teknolojisi aracılığıyla Seedance 2.0 modeline erişmek ve onu kullanmak için pratik bir yol sunuyoruz.',
    },
}
